import React from 'react';
import { Box, Container, Typography, Link, useMediaQuery, useTheme } from '@mui/material';

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box component="footer"
         sx={{
           mt: 'auto',
           py: { xs: 1, sm: 3 },
           borderTop: '1px solid rgba(0, 0, 0, 0.1)',
           backgroundColor: '#f8f9fa'
         }}>
      <Container maxWidth="lg">
        {isMobile ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              © {new Date().getFullYear()} Magna Legal Services
            </Typography>
          </Box>
        ) : (
          <Box sx={{
            display: 'flex', flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center', justifyContent: 'space-between', gap: { xs: 2, md: 3 }
          }}>
            <Box sx={{ display: 'flex', gap: { xs: 2, sm: 3 }, flexWrap: 'wrap', order: { xs: 2, md: 1 } }}>
              {[
                { label: 'About', href: 'https://magnals.com/about-us/' },
                { label: 'Contact', href: 'https://magnals.com/contact-magna-legal-services/' },
                { label: 'Privacy', href: 'https://magnals.com/privacy-policy/' },
              ].map(link => (
                <Link key={link.label} href={link.href} color="secondary" underline="none"
                      sx={{
                        textTransform: 'uppercase', fontWeight: 500, letterSpacing: '0.5px',
                        transition: 'color 0.3s ease', '&:hover': { color: 'primary.main' }
                      }}>
                  {link.label}
                </Link>
              ))}
            </Box>
            <Typography variant="body2" color="text.secondary"
                        sx={{ order: { xs: 1, md: 2 }, textAlign: { xs: 'center', md: 'right' } }}>
              © {new Date().getFullYear()} Magna Legal Services
            </Typography>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default Footer;
